import { type ReactNode } from 'react';

type SummaryItem = {
    itemLabel: string;
    itemValue: string;
}

interface DonationSummaryProps {
    summaryTitle: string;
    summaryItems?: SummaryItem[];
    summaryFooterItems?: SummaryItem[];
    children: ReactNode;
}

const DonationSummary = (props: DonationSummaryProps): JSX.Element => {
    const { summaryTitle, summaryItems, summaryFooterItems, children } = props;

    return (
        <div className="donation-summary-wrapper">
            <div className="donation-summary-title">{summaryTitle}</div>
            <div className="donation-summary-box">
                {summaryItems?.length && (
                    <div className="donation-summary-list">
                        {summaryItems.map(item => {
                            return (
                                <div className="summary-item" key={`summary-item-${item.itemLabel}`}>
                                    <div className="summary-item-label">{item.itemLabel}</div>
                                    <div className="summary-item-value">{item.itemValue}</div>
                                </div>
                            );
                        })}
                    </div>
                )}

                {summaryFooterItems?.length && (
                    <div className="donation-summary-list-footer">
                        {summaryFooterItems.map(item => {
                            return (
                                <div className="summary-item size-lg" key={`summary-item-${item.itemLabel}`}>
                                    <div className="summary-item-label">{item.itemLabel}</div>
                                    <div className="summary-item-value">{item.itemValue}</div>
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
            {children && (
                <div className="donation-summary-content">
                    {children}
                </div>
            )}
        </div>
    );
};

export default DonationSummary;
